export default __webpack_public_path__ + "static/media/video.af1c05f9.mp4";